"use client";

import Image from "next/image";

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography,
} from "@artha/ui";

type CountryRestrictionModalProps = {
  isOpen: boolean;
  title: string;
  subtitle: string;
  actionLabel: string;
  onClose: () => void;
  onShowSimilarJobs: () => void;
};

export const CountryRestrictionModal = ({
  isOpen,
  title,
  subtitle,
  actionLabel,
  onShowSimilarJobs,
}: CountryRestrictionModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      className="mx-0 border border-black p-6 !animate-none"
    >
      <ModalHeader>
        <Image
          src="/images/rejection-illustration.png"
          alt=""
          width={80}
          height={80}
          className="mb-4 object-contain"
        />
        <Typography
          variant="lead"
          className="text-center text-lg font-semibold leading-relaxed text-[#344054]"
        >
          {title}
        </Typography>
      </ModalHeader>

      <ModalBody>
        <Typography
          variant="small"
          className="text-sm leading-relaxed text-[#667085]"
        >
          {subtitle}
        </Typography>
      </ModalBody>

      <ModalFooter>
        <Button className="w-full" onClick={onShowSimilarJobs}>
          {actionLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
